import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FlexLayoutConfig} from '../flex-layout.config';
import {FlexLayoutFieldConfig} from '../flex-layout-field.config';
import {FlexLayoutItem} from '../flex-layout-item';
import {FlexLayoutService} from '../flex-layout.service';

export interface FieldData {
    config: FlexLayoutFieldConfig;
    row: number;
    col: number;
    rowspan: number;
    colspan: number;
}

@Component({
    selector: 'mydocma-dynamic-form-flex-layout',
    styleUrls: ['flex-layout.component.scss'],
    templateUrl: './flex-layout.component.html',
    providers: [
        FlexLayoutService
    ]
})
export class FlexLayoutComponent implements OnChanges {

    @Input()
    public layoutConfig: FlexLayoutConfig;

    public layoutGrid: FlexLayoutItem[] = [];

    constructor(private readonly flexLayoutService: FlexLayoutService) {
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.layoutConfig) {
            this.layoutGrid = this.flexLayoutService.createLayoutGrid(this.layoutConfig);
        }
    }
}
